import api from "./Api";

class RestauranteImpressoraService {
  getRestauranteImpressoraOData(payload) {
    return api
      .get("/OData/RestauranteImpressora" + payload)
      .then((response) => response.data);
  }

  postRestauranteImpressora(payload) {
    return api
      .post("/v1/RestauranteImpressora", payload)
      .then((response) => response.data);
  }

  putRestauranteImpressora(payload) {
    return api
      .put("/v1/RestauranteImpressora", payload)
      .then((response) => response.data);
  }

  deleteRestauranteImpressora(payload) {
    const idDestino = payload.id_restaurante_impressora_destino;
    return api
      .delete(
        "/v1/RestauranteImpressora/" +
          payload.id +
          (idDestino ? "?id_restaurante_impressora_destino=" + idDestino : "")
      )
      .then((response) => response.data);
  }

  vincularProdutos(id, payload) {
    return api
      .put("/v1/RestauranteImpressora/" + id + "/VincularProdutos", payload)
      .then((response) => response.data);
  }

  vincularGrupos(id, payload) {
    return api
      .put("/v1/RestauranteImpressora/" + id + "/VincularGrupos", payload)
      .then((response) => response.data);
  }
}

export default new RestauranteImpressoraService();
